import React from "react";
import { Grid, TextField, Typography } from "@mui/material";
import ModalLayout from "components/ModalLayout";
import MDButton from "components/MDButton";
import CancelButton from "components/CancelButton";

const DriverReminderModal = ({
  driverReminderModalOpen,
  driverReminderForm,
  handleDriverReminderChange,
  handleSendDriverReminder,
  setDriverReminderModalOpen
}) => {
  const disableSend = !driverReminderForm.title || !driverReminderForm.message;

  return (
    <ModalLayout
      open={driverReminderModalOpen}
      onClose={() => setDriverReminderModalOpen(false)}
      title="Driver Reminder"
      subtitle="Send Reminder"
      maxWidth={640}
      headerContent={
        <Typography variant="body2" color="text.secondary" mt={1}>
          Craft a quick reminder for the assigned driver. Keep the message concise and actionable.
        </Typography>
      }
      actions={
        <>
          <CancelButton onClick={() => setDriverReminderModalOpen(false)} />
          <MDButton
            variant="gradient"
            color="warning"
            onClick={handleSendDriverReminder}
            disabled={disableSend}
            sx={{ minWidth: 140 }}
          >
            Send
          </MDButton>
        </>
      }
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            name="title"
            label="Title"
            value={driverReminderForm.title}
            onChange={handleDriverReminderChange}
            fullWidth
            InputProps={{ sx: { borderRadius: 2 } }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            name="message"
            label="Message"
            multiline
            minRows={3}
            value={driverReminderForm.message}
            onChange={handleDriverReminderChange}
            fullWidth
            InputProps={{ sx: { borderRadius: 2 } }}
          />
        </Grid>
      </Grid>
    </ModalLayout>
  );
};

export default DriverReminderModal;
